import { Calendar, SlotInfo, dayjsLocalizer } from "react-big-calendar";
import dayjs, { Dayjs } from "dayjs";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "assets/css/bigCalendar.css";

const localizer = dayjsLocalizer(dayjs);

// import { notiData } from "assets/data/notiData";
import { useEffect, useState } from "react";
import { CalendarNoti, NotiObj } from "utils/types/general.types";
import { MyModal, customToaster } from "ui";
import AddNotiForm from "./AddNotiForm";
import { useAppSelector } from "services/redux/store";
import EditNotiForm from "./EditNotiForm";

export const convertNoti2Calendar = (notiData: NotiObj[]) => {
    const events: CalendarNoti[] = notiData.map((n) => ({
        id: n.id,
        title: n.title,
        start: dayjs(n.scheduleDate).toDate(),
        end: dayjs(n.scheduleDate).add(2, "m").toDate(),
        desc: n.message
    }));
    return events;
};

const MyCalendar = () => {
    const notiData = useAppSelector(
        (state) => state.notifications.notifications
    );
    const mode = useAppSelector((state) => state.site.mode);

    const [openModal, setOpenModal] = useState(false);

    const [events, setEvents] = useState<CalendarNoti[]>([]);
    useEffect(() => {
        setEvents(() => convertNoti2Calendar(notiData));
    }, [notiData]);

    const [startDate, setStartDate] = useState<Dayjs>(dayjs());
    const handleSelectSlot = (slotInfo: SlotInfo) => {
        setOpenModal(true);
        setStartDate(dayjs(slotInfo.start));
        // console.log("day js 2", dayjs(slotInfo.start).add(2, "m"));
    };

    const [openEditModal, setOpenEditModal] = useState(false);
    const [editNoti, setEditNoti] = useState<NotiObj>();
    const handleSelectEvent = (event: CalendarNoti) => {
        const noti = notiData.filter((i) => i.id === event.id)[0];
        setEditNoti(noti);
        setOpenEditModal(true);
    };

    useEffect(() => {
        if (!openEditModal) {
            setEditNoti(undefined);
        }
    }, [openEditModal]);

    return (
        <>
            <Calendar
                localizer={localizer}
                events={events}
                views={["month", "week", "day"]}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                selectable
                onSelectSlot={handleSelectSlot}
                onSelectEvent={handleSelectEvent}
            />
            <MyModal open={openModal} setOpen={setOpenModal}>
                <div className="px-4 py-4">
                    <AddNotiForm
                        start={startDate}
                        showTitle
                        handleSave={() => setOpenModal(false)}
                        handleCloseModal={!openModal}
                    />
                </div>
            </MyModal>

            <MyModal open={openEditModal} setOpen={setOpenEditModal}>
                <div className="px-4 py-4">
                    <EditNotiForm
                        showTitle
                        noti={editNoti}
                        setEditNoti={setEditNoti}
                        handleSave={() => {
                            setOpenEditModal(false);
                            customToaster(
                                "success",
                                "Push Notificatopn Updated",
                                mode
                            );
                        }}
                        handleClose={() => {
                            setOpenEditModal(false);
                            customToaster(
                                "info",
                                "Push Notificatopn Deleted",
                                mode
                            );
                        }}
                        handleCloseModal={!openEditModal}
                    />
                </div>
            </MyModal>
        </>
    );
};

export default MyCalendar;
